import React from "react";
import OutreachList from "../../components/Pages/Outreach/List/List";

const Outreaches = () => {
  return (
    <div>
      <OutreachList />
    </div>
  );
};

export default Outreaches;
